// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";

function isCoordsUnderPolygon(polygon, locationLatLng) {
  var latLng = new (window.google.maps.LatLng)(locationLatLng.lat, locationLatLng.lng);
  return Belt_Array.some(polygon, (function (polygonCoords) {
                var newPolygon = new (window.google.maps.Polygon)({
                      paths: polygonCoords
                    });
                return window.google.maps.geometry.poly.containsLocation(latLng, newPolygon);
              }));
}

export {
  isCoordsUnderPolygon ,
}
/* No side effect */
